import * as React from "react";
import { logger } from "bernie-core";
import { LobNavigation } from "src/components/shared/StorefrontWizard/LobNavigation";
import { LobForms } from "src/components/shared/StorefrontWizard/LobForm";
import { StorefrontWizardRegionProps } from "src/components/shared/StorefrontWizard/typings";
import { LobQueryRouter } from "src/components/shared/StorefrontWizard/LobQueryRouter";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { inject } from "mobx-react";
import { CustomerNotifications } from "components/shared/CustomerNotifications";
import { CustomerNotificationLocation } from "@shared-ui/customer-notifications";
import {
  getWizardLOBFlexComponents,
  getWizardLOBFormChildren,
  getNonWizardFormChildren,
} from "src/components/shared/StorefrontWizard/StorefrontWizardUtils";
import {
  CollapsableContainer,
  CollapsableComponentName,
} from "components/shared/StorefrontWizard/CollapsableContainer/CollapsableContainer.tsx";

@logger("StorefrontWizardRegion")
@inject("wizardState")
export class StorefrontWizardRegion extends React.Component<StorefrontWizardRegionProps> {
  public render() {
    const flexComponent = this.props.flexComponent;
    const context = this.props.context;
    const wizardState = this.props.wizardState;
    const blossomComponent = BlossomComponentFactory.get(this.props as BlossomComponentFactoryProps);

    //default to false if device information is not available
    wizardState.globalWizardState.setIsDesktop(context.deviceInformation);

    if (!flexComponent || !flexComponent.model || !blossomComponent) {
      return null;
    }

    wizardState.globalWizardState.config.useLastSearchForMultiLOB = flexComponent.model.useLastSearchForMultiLOB;

    if (flexComponent.model.defaultLOB) {
      wizardState.globalWizardState.config.navigation.defaultLob = flexComponent.model.defaultLOB;
      wizardState.globalWizardState.config.navigation.activeLob = flexComponent.model.defaultLOB;
    }

    wizardState.globalWizardState.setLastSearchedLob();

    const children = blossomComponent.renderChildren(this.props.logger, this.props.l10n, context);

    if (children.length < 1) {
      return null;
    }

    const wizardLOBs = getWizardLOBFlexComponents(flexComponent.modules);

    const wizardFormChildren = getWizardLOBFormChildren(children);

    const otherFormChildren = getNonWizardFormChildren(children);

    const isStorefrontPage = context.searchContext.pageType.indexOf("Storefront") > -1;

    wizardState.globalWizardState.config.collapsed =
      flexComponent.model.collapsed ?? wizardState.globalWizardState.config.collapsed;

    const { collapsed } = wizardState.globalWizardState.config;

    return (
      <div className="StorefrontWizardRegion">
        <div className="SimpleContainer uitk-flat-border-top uitk-flat-border-bottom" data-testid="main-region">
          <div className="uitk-grid uitk-flex uitk-flex-justify-content-center wizard-padding">
            <CollapsableContainer
              componentName={CollapsableComponentName.STOREFRONT_WIZARD_REGION}
              isCollapsedWizardEnabled={collapsed}
            >
              <div className="uitk-cell all-cell-1-1 all-y-padding-three" data-testid="storefront-region">
                <LobQueryRouter lobs={wizardLOBs} />
                {isStorefrontPage && (
                  <CustomerNotifications
                    location={CustomerNotificationLocation.AFTER_HEADER}
                    className={"all-b-margin-six all-t-margin-six"}
                  />
                )}
                <LobNavigation lobs={wizardLOBs} />
                <LobForms lobForms={wizardFormChildren} />
              </div>
              {otherFormChildren}
            </CollapsableContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default StorefrontWizardRegion;
